export default __webpack_public_path__ + "static/media/user_1.e80a770a.svg";